import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Principal } from '../shared/auth/principal.service';
import { AuthService } from '../shared/auth/auth.service';

@Injectable()
export class TipaltiPayableGuard implements CanActivate {

  constructor(private principal: Principal,
    private authService: AuthService,
    private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>
    | Promise<boolean>
    | boolean {
    return new Promise<boolean>((resolve, reject) => {
      this.authService.publisherIdentity().subscribe(next => {
        if (this.principal.publisher && this.principal.publisher.tipaltiId && !this.principal.publisher.tipaltiPayable) {
          this.router.navigate(['/account/tipalti-account']);
          resolve(false);
        }
        resolve(true);
      });
    });
  }
}
